// May this viewer open a module's pages? — the decision App.tsx's
// RequireModule makes at the route, so a link is only drawn where it leads
// somewhere (UF-04). An inspector opens pallets but not runs
// (DEFAULT_MODULES_BY_ROLE.INSPECTOR): a run number that linked for them would
// bounce them to Home.
//
// The route's other two gates need no mirror here. RequireTenantKind: the
// inspection page is a packhouse route (gPack), like /pallets and /runs, so a
// viewer on it already passes. MoneyGate: it withholds `money: 'core'` modules
// behind an explanatory panel, not a bounce, and pallets and runs are
// 'incidental' anyway.
//
// False while the viewer, the business or the permission map is still loading
// (RequireModule's isPending rule, finding H4): the number shows as plain text
// until the answer is in, and a link never flashes at someone the route would
// refuse.
import { useCurrentUser } from '@/lib/useCurrentUser'
import { useActiveTenant } from '@/lib/useActiveTenant'
import { usePermissions } from '@/lib/usePermissions'
import { hasModule } from '@/lib/modules'

export function useCanOpen(moduleKey: string): boolean {
  const { data: me, isPending: mePending } = useCurrentUser()
  const { data: tenant, isPending: tenantPending } = useActiveTenant()
  const { perms, isPending: permsPending } = usePermissions()
  if (mePending || tenantPending || permsPending) return false
  return hasModule(me ?? null, moduleKey, tenant?.enabledModules ?? null, perms, tenant?.slug)
}
